/**
 * Homework · hand-drawn SVG icon for the «ДОМАШКА» Ticket type pill.
 *
 * Authored: slot_homework_content_engineering · HW.3 · 18 MAY 2026.
 * Spec: Genie pick · form A (folded checklist page) + coral palette + narrower
 *       silhouette (36 wide × 46 tall vs prior 48×50 attempts).
 *
 * Visual: page silhouette with folded top-right corner · 3 checkbox lines ·
 *         first checkbox ticked · subtle fill 0.08 for depth · matches
 *         AtelierChampion / GraduationCap hand-drawn line-art convention.
 *
 * Inherits color from parent via currentColor — host pill sets coral palette
 * (#D85A30 stroke / #FAECE7 bg / #712B13 text).
 */

import type { SVGProps } from 'react';

export function Homework(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 60 60"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      strokeWidth="1.8"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      {/* Page silhouette with folded top-right corner */}
      <path
        d="M14 8 L42 8 L50 16 L50 54 L14 54 Z"
        fill="currentColor"
        fillOpacity="0.08"
      />
      <path d="M14 8 L42 8 L50 16 L50 54 L14 54 Z" />
      {/* Folded corner triangle (darker shading) */}
      <path
        d="M42 8 L42 16 L50 16 Z"
        fill="currentColor"
        fillOpacity="0.20"
      />
      <path d="M42 8 L42 16 L50 16" />
      {/* Checkbox 1 · checked */}
      <rect x="18" y="22" width="6" height="6" rx="1" />
      <path d="M19.2 25.2 L21 27 L23.5 23.5" strokeWidth="1.7" />
      <line x1="27" y1="25" x2="44" y2="25" />
      {/* Checkbox 2 · empty */}
      <rect x="18" y="33" width="6" height="6" rx="1" />
      <line x1="27" y1="36" x2="42" y2="36" />
      {/* Checkbox 3 · empty */}
      <rect x="18" y="44" width="6" height="6" rx="1" />
      <line x1="27" y1="47" x2="39" y2="47" />
    </svg>
  );
}
